export const messages = {
  required: "Обязательное поле",
  email: "Некорректный Email",
  charsAndDigits: "Только буквы и цифры",
  numeric: "Только цифры",
  iban: "28 символов",
  min: "Не менее {{limit}}",
  max: "Не более {{limit}}",
  integer: "Должно быть целым числом",
  minLength: "Минимально  символов {{limit}}",
  maxLength: "Максимально символов {{limit}}",
  phoneOrEmail: "Заполните поле Эл.почта или Основной телефон",
  postcode: "Индекс должен состоять из 6 цифр",
  bankName: "Только символы [Aa-Zz Аа-Яя0-9/-,.””]",
  file: "Файл обязателен. Только форматы *.jpeg; *.jpg; *.pdf, *.png;",
  taxAndContractOriginal: "Файл обязателен. Только форматы: *.pdf",
  maxFileSizeMb: "Максимальный размер: 10MB",
  defaultMessage: "Неверный номер телефона",
  forbiddenErrorMsg: "Номер не доступен для сохранения",
};
